import { gql } from '@apollo/client';

export const DESTINATION_PARTNERS_QUERY = gql`
  query DestinationPartnersQuery {
    destinationPartners {
      id
      name
      slug
      displayName
      filenameSuffix
      s3Config {
        accessKeyId
        secretAccessKey
        region
        bucket
        key
      }
      sftpConfig {
        host
        port
        username
        password
        remotePath
      }
    }
  }
`;

export const DESTINATION_PARTNER_QUERY = gql`
  query DestinationPartnerQuery($id: ID!) {
    destinationPartner(id: $id) {
      id
      name
      slug
      displayName
      filenameSuffix
      s3Config {
        accessKeyId
        secretAccessKey
        region
        bucket
        key
      }
      sftpConfig {
        host
        port
        username
        password
        remotePath
      }
    }
  }
`;

export const DESTINATION_PARTNER_BY_SLUG_QUERY = gql`
  query DestinationPartnerBySlugQuery($slug: String!) {
    destinationPartnerBySlug(slug: $slug) {
      id
      name
      slug
      displayName
      filenameSuffix
      s3Config {
        accessKeyId
        secretAccessKey
        region
        bucket
        key
      }
      sftpConfig {
        host
        port
        username
        password
        remotePath
      }
    }
  }
`;
